export enum KpiMetricTableType {
  WORKFLOW = 'Workflow',
  ACCEPTANCE = 'Acceptance',
  PERFORMANCE = 'Performance',
  COVER_RATIO = 'Cover Ratio',
}
